import styled, { css } from 'styled-components';
import { Form } from 'formik';

import colors from 'styles/colors';
import { CLOSE_ICON_SIZE } from 'components/Wrapper';
import FlexDiv from 'components/FlexDiv';

export const contentStyles = css`
  display: flex;
  flex-direction: column;
  padding: 0 24px 24px calc(${CLOSE_ICON_SIZE} * 2);
  width: 100%;
`;

export const Content = styled(Form)`
  ${contentStyles};
`;

export const FieldsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  justify-content: space-between;
  width: 880px;
  margin-top: 24px;
`;

export const EditorWrapper = styled.div<{ error: boolean }>`
  width: 100%;
  ${({ error }) =>
    error &&
    css`
      .tox {
        border-color: ${colors.error};
      }
    `};
`;

export const FieldTitle = styled(FlexDiv)`
  margin-bottom: 4px;
  font-size: 11px;
`;

export const Label = styled.label`
  margin-left: 12px;
`;

export const EditorMessage = styled.div`
  color: ${colors.error};
  &:before {
    content: '\\00a0';
  }
`;

export const NoticeToolbarStyled = styled.div`
  position: sticky;
  top: -24px;
  z-index: 100;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  column-gap: 32px;
  flex: 1;
  margin: -24px;
  padding: 24px;
  min-width: 0;
  background: #fff;

  h2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    overflow: hidden;
  }
`;

export const NoticeActionsStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  column-gap: 16px;
`;
